export class Constants {
    public static LIST_PAGE_ITEM_COUNT = 20;
} 